
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number as currency (GBP)
 * Shows no decimals for whole numbers, exactly 2 decimals for fractional amounts
 */
export function formatCurrency(value: number): string {
  // Check if the value has decimal places
  const hasDecimals = value % 1 !== 0;
  
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0
  }).format(value);
}
